import React from 'react';
import root from 'window-or-global';
import Logo from './Logo';
import MenuLinks from './MenuLinks';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import Locale from './Locale';
import Message from '../common/Message';
import Link from 'epic-diesel-common/src/components/link/Link';
import FnGamesTour from '../../pages/fortnite-games/components/FnGamesTour';
import withPageDirection from '../../hocs/withPageDirection';
import {Affiliate} from '../../../shared/types';
import {AccountInfo} from '../../reducers/user.reducer';
import {TaxState} from '../../reducers/tax';

//@ts-ignore
import styles from './Header.pcss';

export interface HeaderProps {
    className?: string;
    affiliateAccount: Affiliate;
    accountInfo: AccountInfo;
    configState: any;
    taxState?: TaxState;
}

const Header = ({className, affiliateAccount, accountInfo, configState, taxState}: HeaderProps) => {
    const isLoggedIn = accountInfo && accountInfo.isLoggedIn;
    const taxCountrySanctioned = taxState && taxState.taxCountrySanctioned;
    const enableFnGames = configState && configState.enableFnGames;

    return [
        <Box key="HEADER" className={styles.header}>
            <Logo />

            <MenuLinks
                isLoggedIn={isLoggedIn}
                affiliate={affiliateAccount}
                configState={configState}
                taxCountrySanctioned={taxCountrySanctioned}
            />

            <div className={styles.user}>
                {isLoggedIn ? (
                    <>
                        <span>{accountInfo.displayName}</span>
                        <Link
                            to="/logout"
                            onClick={() => root.sessionStorage && root.sessionStorage.clear()}
                            isExternalUrl={true}>
                            <Message code="epic.affiliate.common.signout" />
                        </Link>
                    </>
                ) : (
                    <Link to="/login" isExternalUrl={true}>
                        <Message code="epic.affiliate.common.signin" />
                    </Link>
                )}
            </div>
            <Locale />
        </Box>,
        <Divider key="divider" className={className} />,
        enableFnGames && <FnGamesTour key="fn-games-tour" />
    ];
};

export default withPageDirection(Header);
